/**
 * Authentication API Endpoints
 * Centralized endpoint definitions
 * Base URL: http://127.0.0.1:1111 (from .env)
 * Prefix: /frontend
 */

const AUTH_ENDPOINTS = {
  // Authentication
  LOGIN: "/frontend/login",
  REGISTER: "/frontend/register",
  LOGOUT: "/frontend/logout",
  DELETEACCOUNT: "/frontend/delete-profile",

  // Registration Flow
  REGISTER_STEP_ONE: "/frontend/register-step-one",
  VERIFY_OTP_LOGIN_SIGNUP: "/frontend/verify-otp-for-login-signup",
  COMPLETE_PROFILE: "/frontend/complete-profile",

  // Password Management
  FORGOT_PASSWORD: "/frontend/forgot-password",
  RESET_PASSWORD: "/frontend/reset-password",
  CHANGE_PASSWORD: "/frontend/change-password",

  // OTP & Verification
  VERIFY_OTP: "/frontend/otp-verify",
  RESEND_OTP: "/frontend/resend-otp",

  // User Profile
  GET_CURRENT_USER: "/frontend/me",
  UPDATE_PROFILE: "/frontend/update-profile",
  VIEW_PROFILE: "/frontend/view-profile",

  // Token Management
  REFRESH_TOKEN: "/frontend/refresh-token",

  // Registration Data
  GET_ROLES: "/frontend/fetch-role",
  GET_EXPERIENCE: "/frontend/fetch-experience",
  GET_ALL_STATES: "/frontend/fetch-united-states",
  GET_ALL_CITIES: "/frontend/city-names",
  GET_LOCATION_CHOICE: "/frontend/fetch-location",

  // Social Login
  SOCIAL_LOGIN: "/frontend/social-login",
};

export default AUTH_ENDPOINTS;
